import React, {FC} from 'react';
import {pricingFlag} from '../../../images/svgIcons';
import {IFlag} from '../../types';
import './styles.scss';
const Flag: FC<IFlag> = ({color}) => {
  return <div className={`position-absolute ${color ? color : ''} price-flag`}>{pricingFlag}</div>;
};

export default Flag;
